import { idGenerator } from "@/utils/idGenerator";
import { getRandomTailwindColor } from "@/utils/tailwindColors";

import type { NodeJson } from "@corca/data";
import type { UnifiedLatexParser } from "@corca/latex";

export type ParseResult = {
  dom: Document;
  nodes: NodeJson[];
  errors: [string, string][];
};

export class LatexParser {
  static async create() {
    const { UnifiedLatexParser } = await import(/* webpackChunkName: "latex" */ "@corca/latex");
    return new LatexParser(new UnifiedLatexParser(idGenerator));
  }

  constructor(readonly unifiedParser: UnifiedLatexParser) {}

  private fillDefaults(nodes: NodeJson[]) {
    for (const node of nodes) {
      if (node.type === "variable" && !node.props.color) {
        node.props.color = getRandomTailwindColor(
          node.children.find((n) => n.type === "symbol")?.props.value ?? "",
        );
      }
      this.fillDefaults(node.children);
    }
  }

  parse(input: string, force = false): ParseResult {
    const res = this.unifiedParser.parse(input, force);

    this.fillDefaults(res.nodes);

    return {
      ...res,
      dom: res.xml.toDom(document),
    };
  }
}
